(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["paradox-trade-products"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', (event) => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement) || input.type !== 'checkbox') return;
      const fieldset = input.closest('.pm-trade-products');
      if (!fieldset) return;
      const output = fieldset.querySelector('.pm-trade-products__selection');
      const selected = Array.from(fieldset.querySelectorAll('input:checked'), item => item.value);
      output.textContent = selected.length ? output.dataset.selectedLabel + ' (' + selected.length + '): ' + selected.join(', ') : output.dataset.emptyLabel;
    });
  } catch(e) { console.error(e); }
})();

})();
